import React from 'react'
import { Stack } from '@mui/material'
import { useGlobalState } from 'state'
import { RoadSymbols } from 'common/consts'

export const LegendRoadRegulation = () => {
  const state = useGlobalState()
  const isVisiblity: boolean = React.useMemo(() => state.app.roadRegulation, [state.app.roadRegulation])

  return (
    <>
      { isVisiblity && (
        <Stack direction={'column'}>
          <Stack sx={{
            fontSize: 11,
            lineHeight: 1.3,
            textAlign: 'right',
            fontWeight: 'bold',
            whiteSpace: 'pre-wrap',
            textShadow: '1px 1px 0 #ffffff, -1px 1px 0 #ffffff, 1px -1px 0 #ffffff, -1px -1px 0 #ffffff',
            mb: '3px'
          }}>道路規制種別</Stack>
          <Stack
            direction={'column'}
            alignItems={'flex-end'}
            spacing={0.4}
            border={'rgb(160, 160, 160, 0.9) 1px solid'}
            bgcolor={'rgb(250, 250, 250, 0.8)'}
            py={'3px'}
            px={'5px'}
          >
            { RoadSymbols.map((symbol, index) => {
              return (
                <Stack key={index} direction={'row'} spacing={0.3} alignItems={'center'}>
                  <Stack sx={{
                    fontSize: 10,
                    lineHeight: 1.3,
                    textAlign: 'right',
                    fontWeight: 'bold',
                    whiteSpace: 'pre-wrap',
                    textShadow: '1px 1px 0 #ffffff, -1px 1px 0 #ffffff, 1px -1px 0 #ffffff, -1px -1px 0 #ffffff',
                  }}>{symbol.name}</Stack>
                  <img src={symbol.url} height={14} />
                </Stack>
              )
            }) }
          </Stack>
        </Stack>
      )}
    </>
  )
}
